import api from 'app/AxiosInstance'
import { baseUrl } from 'app/Utils/Config'

const token = localStorage.getItem(`AuthToken`)

export const getAllDepartments = async () => {
  try {
    const {
      data: { data },
    } = await api.get(`${baseUrl}/departments/?search=&sort=&page=&limit=`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    if (data) {
      return {
        options: data?.departments,
      }
    }
  } catch (error) {
    if (error.response) {
      return {
        options: [],
      }
    }
  }
}
